import { render } from "./TreeNode.vue?vue&type=template&id=2f0d200c&scoped=true&ts=true"
import script from "./TreeNode.vue?vue&type=script&lang=ts"
export * from "./TreeNode.vue?vue&type=script&lang=ts"

import "./TreeNode.vue?vue&type=style&index=0&id=2f0d200c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/Profectus/Profectus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0d200c"]])

export default __exports__